var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VuePhoneNumberInput',{attrs:{"color":"#fb6340","size":"lg","required":_vm.required,"no-example":true,"fetch-country":true},on:{"update":_vm.onChangePhoneNumber},model:{value:(_vm.phoneNumberModel),callback:function ($$v) {_vm.phoneNumberModel=$$v},expression:"phoneNumberModel"}})
}
var staticRenderFns = []

export { render, staticRenderFns }